import eFManagementStore from "../../Store/marco/emissionFactorManagementStore";
import Select from "react-select";

const Selector = ({
  smallSelector,
  label,
  defaultValue,
  options,
  dataKey,
  dataKeyName,
  styles,
  width,
  isDisabled,
}) => {
  return (
    <div className={smallSelector === true ? null : styles.inputWrap}>
      {label ? (
        <label>
          <span style={{ color: "red" }}>* </span>
          {label}
        </label>
      ) : null}

      <Select
        value={
          eFManagementStore.addCustomEFData?.[dataKey]
            ? eFManagementStore.addCustomEFData?.[dataKeyName]
            : ""
        }
        isDisabled={isDisabled}
        options={options}
        onChange={(selectedOption) => {
          const oldValue = eFManagementStore.addCustomEFData?.[dataKey];
          const newValue = selectedOption?.value || "";

          eFManagementStore._handleSetCustomEFData({
            [`${dataKey}`]: newValue,
          });
          eFManagementStore._handleSetCustomEFData({
            [`${dataKeyName}`]: selectedOption?.label || "",
          });

          // Handle dependent fields clearing
          const slotSpecificFields = {
            firstGHG: [
              "firstFactorValue",
              "firstUncertainlyLower",
              "firstUncertainlyUpper",
            ],
            secondGHG: [
              "secondFactorValue",
              "secondUncertainlyLower",
              "secondUncertainlyUpper",
            ],
            thirdGHG: [
              "thirdFactorValue",
              "thirdUncertainlyLower",
              "thirdUncertainlyUpper",
            ],
          };

          const fieldsToReset = slotSpecificFields[dataKey];
          if (fieldsToReset) {
            fieldsToReset.forEach((field) => {
              eFManagementStore._handleSetCustomEFData({ [field]: 0 });
            });

            // Handle Global shared GWP fields
            if (oldValue === "HFCs" && newValue !== "HFCs") {
              eFManagementStore._handleSetCustomEFData({ HFCsGWP: 0 });
            }
            if (oldValue === "PFCs" && newValue !== "PFCs") {
              eFManagementStore._handleSetCustomEFData({ PFCsGWP: 0 });
            }
          }
        }}
        placeholder={defaultValue || ""}
        styles={{
          control: (base) => ({
            ...base,
            cursor: "pointer",
            border: "1px solid #ccc",
            borderRadius: "4px",
            width: width ? width : "350px",
            height: "43px",
            minHeight: "43px",
            maxHeight: "43px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "nowrap",
          }),
          input: (base) => ({
            ...base,
            padding: "0",
            margin: "0",
            lineHeight: "43px",
            fontSize: "14px",
          }),
          menu: (base) => ({
            ...base,
            padding: "0",
            width: width ? width : "350px",
            borderRadius: "4px",
            marginTop: "4px",
            border: "1px solid #ccc",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            zIndex: 3,
          }),
          valueContainer: (base) => ({
            ...base,
            padding: "0",
            paddingLeft: "10px",
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            overflow: "hidden",
          }),
          singleValue: (base) => ({
            ...base,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: "200px",
            overflowY: "auto",
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? "#e0e0e0" : "#fff",
            color: state.isSelected ? "#007bff" : "#333",
            padding: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#d5d5d5",
            },
          }),
          placeholder: (base) => ({
            ...base,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            color: "#333",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "normal",
          }),
        }}
        components={{
          IndicatorSeparator: () => null,
        }}
      />
    </div>
  );
};

export default Selector;
